import PropTypes              from 'prop-types';
import React                  from 'react';
import { Link } from 'react-router';
import styles                 from './ProgressBar.scss';

export default class ProgressBar extends React.Component {
  constructor() {
    super();
    this.state = {
      percent: null
    }
  }

  componentDidMount() {
    this.setState({
      percent: this.props.percent
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      percent: nextProps.percent
    })
  }

  render() {
    let width = this.state.percent >= 0 && this.state.percent <= 100 ? this.state.percent + '%' : 0;

    return (
      <div className={styles.progressBar}>
        <div style={{ width: width }}></div>
      </div>
    );
  }
}

